/**
 * @module getRouterBasename
 */
const { getCurrentLanguage, getLanguages } = require('./languages');

/**
 * Convenience function to return the Magnolia router base.
 *
 * @param {MgnlEnvVars} mgnlEnvVars - Object of required Magnolia ENV variables. If not set, defaults and attempts to use `process.env`.
 *
 * @returns {string} The router base.
 */
function getRouterBasename(mgnlEnvVars) {
  const envVars = mgnlEnvVars || process.env;
  const nodeName = envVars.REACT_APP_MGNL_APP_BASE;
  const languages = getLanguages(envVars);

  /* istanbul ignore next */
  if (window && window.location) {
    const { pathname } = window.location;

    if (pathname.indexOf(nodeName) > -1) {
      return pathname.replace(new RegExp(`${nodeName}.*`), '') + nodeName;
    }
  }

  const currentLanguage = getCurrentLanguage(envVars);

  return languages[0] === currentLanguage ? '/' : `/${currentLanguage}`;
}

module.exports = {
  getRouterBasename,
};
